<template>
    <div>
        <div id="tax-msg-div"></div>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <kt-form-section v-if="tax_status === 'setTaxData'">
                <div class="section-header">
                    {{ $t('label.shaparak_tax_inquiries') }}
                </div>
                <div>
                    <table v-if="tax_data.inquiries.length > 0" class="table text-center">
                        <thead>
                        <tr>
                            <th>{{ $t('label.inquiry_tracking_number') }}</th>
                            <th>{{ $t('label.inquiry_status') }}</th>
                            <th>{{ $t('label.registration_status') }}</th>
                            <th>{{ $t('label.follow_code') }}</th>
                            <th>{{ $t('label.inquiry_date') }}</th>
                            <th>{{ $t('label.error_detail') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(inquiry, index) in  tax_data.inquiries">
                            <td>
                                <div class="m-tooltip" dir="ltr">
                                    <span class="m-tooltip-text">{{ inquiry.tracking_number }}</span>
                                    <div>{{ getTrackingNumber(inquiry.tracking_number) }}</div>
                                </div>
                            </td>
                            <td>{{ shTaxStatusStr.get(inquiry.status) }}</td>
                            <td>{{ registrationStatusStr.get(inquiry.registration_status) }}</td>
                            <td>{{ inquiry.follow_code }}</td>
                            <td dir="ltr">{{ inquiry.created_at }}</td>
                            <td dir="ltr">
                                <div v-if="inquiry.status == 5">
                                    <button class="btn" data-toggle="modal" :data-target="'#req_error' + index"><i class="fa fa-info"></i></button>
                                    <div :id="'req_error' + index" class="modal fade" role="dialog">
                                        <div class="modal-dialog">
                                            <div class="modal-content" dir="rtl">
                                                <div class="modal-header text-center">
                                                    <p>{{ $t('label.error_detail') }}</p>
                                                </div>
                                                <div class="modal-body">
                                                    <p>{{ inquiry.error_description }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <kt-col v-else class="mb-4">
                        <p class="badge badge-warning w-100 p-3 text-dark" style="font-size:1.2em">
                            {{ $t('label.not_inquired_yet') }}
                        </p>
                    </kt-col>
                </div>

                <kt-row>
                    <kt-col>
                        <kt-form-action>
                            <button
                                    class="btn btn-md btn-success btn-wide"
                                    type="button"
                                    id="send_new_tax_inquiry_btn"
                                    @click="inquiryTaxState"
                            >
                                {{ $t('label.submit_tax_inquiry_again') }}
                            </button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
        <br>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <kt-form-section v-if="tax_status === 'setTaxData'">
                <div class="section-header">
                    {{ $t('label.shaparak_tax_requests') }}
                </div>
                <div>
                    <table v-if="tax_data.requests.length > 0" class="table text-center">
                        <thead>
                        <tr>
                            <th>{{ $t('label.inquiry_tracking_number') }}</th>
                            <th>{{ $t('label.inquiry_status') }}</th>
                            <th>{{ $t('label.shahkar_valid') }}</th>
                            <th>{{ $t('label.tpr_id') }}</th>
                            <th>{{ $t('label.follow_code') }}</th>
                            <th>{{ $t('label.request_date') }}</th>
                            <th>{{ $t('label.error_detail') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(request, index) in  tax_data.requests">
                            <td>
                                <div class="m-tooltip" dir="ltr">
                                    <span class="m-tooltip-text">{{ request.tracking_number }}</span>
                                    <div>{{ getTrackingNumber(request.tracking_number) }}</div>
                                </div>
                            </td>
                            <td>{{ shTaxStatusStr.get(request.status) }}</td>
                            <td>{{ getShahkarValid(request.shahkar_valid) }}</td>
                            <td>
                                <div class="m-tooltip" dir="ltr">
                                    <span class="m-tooltip-text">{{ request.tpr_id }}</span>
                                    <div>{{ getTrackingNumber(request.tpr_id) }}</div>
                                </div>
                            </td>
                            <td>{{ request.follow_code }}</td>
                            <td dir="ltr">{{ request.created_at }}</td>
                            <td dir="ltr">
                                <div v-if="request.status == 5">
                                    <button class="btn" data-toggle="modal" :data-target="'#req_error' + index"><i class="fa fa-info"></i></button>
                                    <div :id="'req_error' + index" class="modal fade" role="dialog">
                                        <div class="modal-dialog">
                                            <div class="modal-content" dir="rtl">
                                                <div class="modal-header">
                                                    <p>{{ $t('label.error_detail') }}</p>
                                                </div>
                                                <div class="modal-body">
                                                    <p>{{ request.error_description }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <kt-col v-else class="mb-4">
                        <p class="badge badge-warning w-100 p-3 text-dark" style="font-size:1.2em">
                            {{ $t('label.not_requested_yet') }}
                        </p>
                    </kt-col>
                </div>

                <kt-row>
                    <kt-col>
                        <kt-form-action>
                            <button
                                    class="btn btn-md btn-success btn-wide"
                                    type="button"
                                    id="send_new_tax_request_btn"
                                    @click="sendNewTaxRequest"
                            >
                                {{ $t('label.submit_tax_request_again') }}
                            </button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import $ from "jquery";
    import { gatewayService } from '@/common/api.service'
    import { KTApp } from '@/plugins/core/app'
    import { shTaxStatusStr, registrationStatusStr } from "@/constants/shaparakTaxStatus";
    import { i18n } from '@/plugins/i18n'

    export default {
        computed: {
            ...mapGetters('gateway', {
                tax_data: 'tax_data',
                tax_status: 'tax_data_status'
            }),
            shTaxStatusStr() {
                return shTaxStatusStr
            },
            registrationStatusStr() {
                return registrationStatusStr
            },
        },
        mounted() {
            this.$store.dispatch('gateway/fetchTaxData',this.$route.params.hashid)
        },
        methods: {
            inquiryTaxState(e) {
                let hashid = this.$route.params.hashid
                let btn = $('#send_new_tax_inquiry_btn');
                KTApp.progress(btn)
                gatewayService.resendTaxInquiry(hashid).then(response => {
                    this.showMsg($('#tax-msg-div'), 'success', response.data.message)
                    this.$store.dispatch('gateway/fetchTaxData',this.$route.params.hashid)
                }).catch(({response}) => {
                    this.showMsg($('#tax-msg-div'), 'danger', response.data.message)
                })
                KTApp.unprogress(btn)
            },
            sendNewTaxRequest(e) {
                let hashid = this.$route.params.hashid
                let btn = $('#send_new_tax_request_btn');
                KTApp.progress(btn)
                gatewayService.resendTaxRequest(hashid).then(response => {
                    this.showMsg($('#tax-msg-div'), 'success', response.data.message)
                    this.$store.dispatch('gateway/fetchTaxData',this.$route.params.hashid)
                }).catch(({response}) => {
                    this.showMsg($('#tax-msg-div'), 'danger', response.data.message)
                })
                KTApp.unprogress(btn)
            },
            getTrackingNumber(tracking_number) {
                if (tracking_number.length < 11) {
                    return tracking_number
                }
                return tracking_number.substring(0,10) + '...'
            },
            getShahkarValid(shahkar_valid) {
                if (shahkar_valid) {
                    return i18n.t('label.yes')
                }
                return i18n.t('label.no')
            }
        }
    }
</script>

<style>
    .m-tooltip {
        position: relative;
    }
    .m-tooltip .m-tooltip-text {
        visibility: hidden;
        /*width: 120px;*/
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 3px 5px;

        /* Position the tooltip */
        position: absolute;
        z-index: 1000;
    }

    .m-tooltip:hover .m-tooltip-text {
        visibility: visible;
    }
</style>